/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileReportParameters } from '../../models/profile-report-parameters';
import { ProfileReportResponse } from '../../models/profile-report-response';

export interface ProfileReportTimeCompareDownload$Params {

/**
 * ID of profile
 */
  id: number;
  firstRangeFrom: number;
  firstRangeTo: number;
  secondRangeFrom: number;
  secondRangeTo: number;
      body: ProfileReportParameters
}

export function profileReportTimeCompareDownload(http: HttpClient, rootUrl: string, params: ProfileReportTimeCompareDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportResponse>> {
  const rb = new RequestBuilder(rootUrl, profileReportTimeCompareDownload.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('firstRangeFrom', params.firstRangeFrom, {});
    rb.path('firstRangeTo', params.firstRangeTo, {});
    rb.path('secondRangeFrom', params.secondRangeFrom, {});
    rb.path('secondRangeTo', params.secondRangeTo, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileReportResponse>;
    })
  );
}

profileReportTimeCompareDownload.PATH = '/rest/profile/{id}/report/time-compare/{firstRangeFrom}/{firstRangeTo}/{secondRangeFrom}/{secondRangeTo}';
